"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keyCodeWindowsRight = exports.keyCodeWindowsOpera = exports.keyCodeWindowsLeft = exports.keyCodeTilde = exports.keyCodeTab = exports.keyCodeSpace = exports.keyCodeShift = exports.keyCodeScrollLock = exports.keyCodeQuote = exports.keyCodePrint = exports.keyCodePeriod = exports.keyCodePageUp = exports.keyCodePageDown = exports.keyCodeOpenBracket = exports.keyCodeNumPadPlus = exports.keyCodeNumPadMultiply = exports.keyCodeNumPadMinus = exports.keyCodeNumPadDot = exports.keyCodeNumPadDivide = exports.keyCodeNumPad9 = exports.keyCodeNumPad8 = exports.keyCodeNumPad7 = exports.keyCodeNumPad6 = exports.keyCodeNumPad5 = exports.keyCodeNumPad4 = exports.keyCodeNumPad3 = exports.keyCodeNumPad2 = exports.keyCodeNumPad1 = exports.keyCodeNumPad0 = exports.keyCodeNumLock = exports.keyCodeMinus2 = exports.keyCodeMinus = exports.keyCodeMenu = exports.keyCodeInsert = exports.keyCodeHome = exports.keyCodeFunction9 = exports.keyCodeFunction8 = exports.keyCodeFunction7 = exports.keyCodeFunction6 = exports.keyCodeFunction5 = exports.keyCodeFunction4 = exports.keyCodeFunction3 = exports.keyCodeFunction2 = exports.keyCodeFunction12 = exports.keyCodeFunction11 = exports.keyCodeFunction10 = exports.keyCodeFunction1 = exports.keyCodeForwardSlash = exports.keyCodeEscape = exports.keyCodeEquals3 = exports.keyCodeEquals2 = exports.keyCodeEquals = exports.keyCodeEnter = exports.keyCodeEnd = exports.keyCodeDelete = exports.keyCodeCtrl = exports.keyCodeComma = exports.keyCodeColon2 = exports.keyCodeColon = exports.keyCodeCloseBracket = exports.keyCodeCapsLock = exports.keyCodeBreak = exports.keyCodeBackSlash = exports.keyCodeBackSpace = exports.keyCodeArrowUp = exports.keyCodeArrowRight = exports.keyCodeArrowLeft = exports.keyCodeArrowDown = exports.keyCodeAlt = void 0;
exports.keyCodeAlt = 18;
exports.keyCodeArrowDown = 40;
exports.keyCodeArrowLeft = 37;
exports.keyCodeArrowRight = 39;
exports.keyCodeArrowUp = 38;
exports.keyCodeBackSpace = 8;
exports.keyCodeBackSlash = 220;
exports.keyCodeBreak = 19;
exports.keyCodeCapsLock = 20;
exports.keyCodeCloseBracket = 221;
exports.keyCodeColon = 186;
exports.keyCodeColon2 = 59;
exports.keyCodeComma = 188;
exports.keyCodeCtrl = 17;
exports.keyCodeDelete = 46;
exports.keyCodeEnd = 35;
exports.keyCodeEnter = 13;
exports.keyCodeEquals = 187;
exports.keyCodeEquals2 = 61;
exports.keyCodeEquals3 = 107;
exports.keyCodeEscape = 27;
exports.keyCodeForwardSlash = 191;
exports.keyCodeFunction1 = 112;
exports.keyCodeFunction10 = 121;
exports.keyCodeFunction11 = 122;
exports.keyCodeFunction12 = 123;
exports.keyCodeFunction2 = 113;
exports.keyCodeFunction3 = 114;
exports.keyCodeFunction4 = 115;
exports.keyCodeFunction5 = 116;
exports.keyCodeFunction6 = 117;
exports.keyCodeFunction7 = 118;
exports.keyCodeFunction8 = 119;
exports.keyCodeFunction9 = 120;
exports.keyCodeHome = 36;
exports.keyCodeInsert = 45;
exports.keyCodeMenu = 93;
exports.keyCodeMinus = 189;
exports.keyCodeMinus2 = 109;
exports.keyCodeNumLock = 144;
exports.keyCodeNumPad0 = 96;
exports.keyCodeNumPad1 = 97;
exports.keyCodeNumPad2 = 98;
exports.keyCodeNumPad3 = 99;
exports.keyCodeNumPad4 = 100;
exports.keyCodeNumPad5 = 101;
exports.keyCodeNumPad6 = 102;
exports.keyCodeNumPad7 = 103;
exports.keyCodeNumPad8 = 104;
exports.keyCodeNumPad9 = 105;
exports.keyCodeNumPadDivide = 111;
exports.keyCodeNumPadDot = 110;
exports.keyCodeNumPadMinus = 109;
exports.keyCodeNumPadMultiply = 106;
exports.keyCodeNumPadPlus = 107;
exports.keyCodeOpenBracket = 219;
exports.keyCodePageDown = 34;
exports.keyCodePageUp = 33;
exports.keyCodePeriod = 190;
exports.keyCodePrint = 44;
exports.keyCodeQuote = 222;
exports.keyCodeScrollLock = 145;
exports.keyCodeShift = 16;
exports.keyCodeSpace = 32;
exports.keyCodeTab = 9;
exports.keyCodeTilde = 192;
exports.keyCodeWindowsLeft = 91;
exports.keyCodeWindowsOpera = 219;
exports.keyCodeWindowsRight = 92;
//# sourceMappingURL=key-codes.js.map